import React, { cloneElement, Fragment } from "react";
import { useHistory } from "react-router-dom";

const Closer = ( props ) => {

  const history = useHistory();

  return cloneElement( props.children || <Fragment />, { onClick : history.goBack } );

};

export default Closer;
